import React from 'react';
import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import { SubPageLayout } from '../sub-page-layout';
import { EntitySearch as EntitySearchComponent } from '../components/entity-search';

export const EntitySearch: React.FC<any> = (_props) => {
  return (
    <SubPageLayout header={<PageHeader title={<Typography.Title
      className="staff-title"
    >
      Entities Search
    </Typography.Title>} />}
    >
      <EntitySearchComponent />
    </SubPageLayout>
  );
};
